export enum MeasurementSystem {
  inch = <any>'inch',
  cm = <any>'cm'
}
